import { Component, Input, ViewEncapsulation } from '@angular/core';
import { ShelvableBackend } from '../../services/ShelvableBackend/ShelvableBackend';
import { Library } from '../../services/ShelvableBackend/Library';
import { GoogleData } from '../../services/GoogleData/GoogleData';

import { StateService } from '@uirouter/angular';

import { Observable, BehaviorSubject, Subject } from 'rxjs';

@Component({
    selector: 'fullSearch',
    templateUrl: './full-search.html',
    styleUrls: ['./full-search.css', './full-search.mobile.css'],
    encapsulation: ViewEncapsulation.None
})

export class FullSearchComponent {
    query:string;
    newQuery:Subject<string> = new BehaviorSubject<string>(null);

    googleData:GoogleData;
    stateService:StateService
    authState:any;
    private maxBooks:Number = Number.MAX_SAFE_INTEGER;
    books:any[] = [];
    loadingBooks:boolean = false;
    bannerDismissed:boolean = false;
    isLoggedIn:Observable<boolean>;

    constructor(shelvableBackend:ShelvableBackend, googleData:GoogleData, stateService:StateService) {
        this.googleData = googleData;
        this.stateService = stateService;

        this.query = decodeURIComponent(stateService.params.q || '');
        this.newQuery.next(this.query);

        this.authState = shelvableBackend.authState;

        this.isLoggedIn = shelvableBackend.loggedInUserObs.isLoggedIn;

        this.loadMore();
    }

    async loadMore() {
        if (!this.query || this.loadingBooks) {
            return;
        }
            
        if (this.books.length >= this.maxBooks) {
            return;
        }
        this.loadingBooks = true;

        try {
            var bookList = await this.googleData.getGoogleBooksList(this.query, this.books.length, 40);
            this.maxBooks = bookList.totalItems;
            this.books = bookList.books;
            this.loadingBooks = false;
        } catch (err) {
            console.error(err);
        }
        
    }

    async search() {
        var newQuery = await this.newQuery.take(1).toPromise();
        if (newQuery && newQuery !== this.query) {
            this.stateService.go('search', {q: newQuery});
        }
    }
    
}



// WEBPACK FOOTER //
// ./web/static/components/full-search/full-search.ts